import React from "react";
import Map from "components/comp/Map";
import Com from "components/styledComp/CommStyledComp";

const Location = () => {

  return (
    <main className="company page-main company-more-wrap">
      <section className="page-heading-wrap">
        <Com.H3PageHeadTitle>
          오시는 길
        </Com.H3PageHeadTitle>
        <p className="page-heading-desc">1호선 의왕역 · 군포산업진흥원 617호</p>
       </section>
      <section>
          <Map/>
        <div className="company-location">
          <div className="location-content">
          <ul className="location-list">
              <li>
                <div className="location-list-title">Address</div>
                <div className="location-list-cont">
                  우편번호 15880<br/>
                  경기도 군포시 군포첨단산업2로22번길 5<br/>
                  군포산업진흥원 617호
                </div>
              </li>
            <li>
              <div className="location-list-title">교통</div>
              <div className="location-list-cont">
                1호선 의왕역 1번 출구 도보 약 15분<br/>
                의왕역 → 버스(100, 100-1, 7, 55, 22 등) → <br/>
                부곡2단지아파트후문앞 하차
              </div>
            </li>
            <li>
              <div className="location-list-title">FAX</div>
              <div className="location-list-cont">
                0504-133-8287
              </div>
            </li>
            <li>
              <div className="location-list-title">E-mail</div>
              <div className="location-list-cont">
                <a href="mailto:admin@hyds.kr">admin@hyds.kr</a>
              </div>
            </li>
          </ul>
          </div>
        </div>
      </section>
       
    </main>
  );
};

export default Location;
